<template>
  <div class="contain">
    <!-- 검색 조건 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="{ tablet: 'top' }[$device.currentSize] ?? 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="8">
            <el-form-item :label="$t('옵션 값 or 명')">
              <el-input v-model="searchForm.optionNm" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼-->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('OptionSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('OptionAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('OptionUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('OptionDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('OptionAdd') || checkAuthActionAccess('OptionUp')"
        :size="size"
        @click="save"
        icon="el-icon-check"
        :disabled="btn.saveDisabled"
        style="float: right"
        class="hide-on-mobile"
        >{{ $t('저장') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-row :gutter="20">
      <el-col :md="16">
        <el-table
          :height="tableHeight"
          ref="table"
          border
          stripe
          highlight-current-row
          tooltip-effect="dark"
          :data="tableData"
          :size="size"
          :empty-text="$t('데이타 없음')"
          @row-click="handleRowClick"
          @select="handleRowChecked">
          <el-table-column
            :label="tableData.length.toString()"
            type="index"
            width="55"
            align="center"
            sortable
            :fixed="!$device.mobile"
            label-class-name="data_cnt"></el-table-column>
          <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>
          <el-table-column
            :label="$t('옵션ID')"
            prop="optionId"
            min-width="150"
            align="center"
            :fixed="!$device.mobile"></el-table-column>
          <el-table-column :label="$t('옵션명')" prop="optionNm" min-width="150" sortable></el-table-column>
          <el-table-column :label="$t('옵션값')" prop="optionVal" min-width="150" sortable></el-table-column>
          <el-table-column :label="$t('옵션 참조값1')" prop="optionRef1" min-width="150" sortable></el-table-column>
          <el-table-column :label="$t('옵션 참조값2')" prop="optionRef2" min-width="150" sortable></el-table-column>
          <el-table-column
            :label="$t('사용 가능 여부')"
            prop="useYn"
            min-width="110"
            align="center"
            :formatter="mainVue.formatterCode"></el-table-column>
          <el-table-column :label="$t('옵션 설명')" prop="optionDesc" min-width="300"></el-table-column>
        </el-table>
      </el-col>

      <el-col :md="8">
        <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
          <div slot="header">
            <span>{{ $t('옵션') }}</span>
            <span v-if="'I' == inputForm.statu">{{ $t('추가') }}</span>
            <span v-if="'U' == inputForm.statu">{{ $t('수정') }}</span>
          </div>
          <div>
            <el-form
              :model="inputForm"
              :label-width="$device.mobile ? `` : `120px`"
              label-suffix=":"
              :size="size"
              :disabled="fromDisabled"
              @submit.native.prevent>
              <el-form-item :label="$t('옵션ID')" :error="formError.optionId" required>
                <el-input
                  v-model="inputForm.optionId"
                  maxlength="50"
                  clearable
                  v-if="'I' === inputForm.statu"
                  show-word-limit></el-input>
                <span v-else class="show_cd">{{ inputForm.optionId }}</span>
              </el-form-item>
              <el-form-item :label="$t('옵션명')" :error="formError.optionNm" required>
                <el-input v-model="inputForm.optionNm" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('옵션값')" :error="formError.optionVal" required>
                <el-input v-model="inputForm.optionVal" maxlength="1000" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('옵션 참조값1')" :error="formError.optionRef1">
                <el-input v-model="inputForm.optionRef1" maxlength="1000" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('옵션 참조값2')" :error="formError.optionRef2">
                <el-input v-model="inputForm.optionRef2" maxlength="1000" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('사용 가능 여부')" required>
                <combo :data="mainVue.code.useYn" :model="inputForm.useYn" @change="inputForm.useYn = $event"></combo>
              </el-form-item>
              <el-form-item :label="$t('옵션 설명')">
                <el-input v-model="inputForm.optionDesc" type="textarea" maxlength="250" show-word-limit></el-input>
              </el-form-item>
            </el-form>
            <el-button
              v-if="checkAuthActionAccess('OptionAdd') || checkAuthActionAccess('OptionUp')"
              :size="size"
              @click="save"
              icon="el-icon-check"
              :disabled="btn.saveDisabled"
              style="float: right"
              class="hide-on-desktop"
              >{{ $t('저장') }}</el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import mainVueMixin from '@/mixins/mainVueMixin'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/option'

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    return data
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    'inputForm.optionId': function (newVal, oldVal) {
      if ('' != newVal && 'I' === this.inputForm.statu) {
        this.chkOptionId()
      }
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        optionNm: '',
        useYn: 'Y',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        optionId: '',
        optionNm: '',
        optionVal: '',
        optionRef1: '',
        optionRef2: '',
        optionDesc: '',
        useYn: 'Y',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        optionId: '',
        optionNm: '',
        optionVal: '',
        optionRef1: '',
        optionRef2: '',
        optionDesc: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].optionId
      }
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.optionId,
        function (result) {
          result.statu = 'U'

          this.inputForm = result

          this.formError = this.initFormError()

          this.btn.saveDisabled = false
          this.fromDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true
          this.btn.saveDisabled = true
          this.fromDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('옵션 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.optionId,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.search()
          }.bind(this),
          true
        )
      }
    },
    // 옵션ID체크
    chkOptionId: function () {
      this.mainVue.$axios.patchNonLoading(
        this.url + '/chk/' + this.inputForm.optionId,
        null,
        null,
        function (result) {
          if ('' == result) {
            this.formError.optionId = ''
            this.btn.saveDisabled = false
          } else {
            this.formError.optionId = this.$t('이미 사용중인 옵션ID입니다.')
            this.btn.saveDisabled = true
          }
        }.bind(this),
        false
      )
    },
  },
}
</script>
